<script setup lang="ts">
import PrimeChip from 'primevue/chip';
import CraigImg from '../assets/images/avatars/vismocraig.webp';
import JoeImg from '../assets/images/avatars/vismojoe.webp';
import NinoImg from '../assets/images/avatars/vismonino.webp';

type Props = {
  who: 'joe' | 'craig' | 'nino';
};

const names = new Map<Props['who'], string>([
  ['joe', 'Joe'],
  ['craig', 'Craig'],
  ['nino', 'Nino'],
]);

const images = new Map<Props['who'], string>([
  ['joe', JoeImg],
  ['craig', CraigImg],
  ['nino', NinoImg],
]);

defineProps<Props>();
</script>

<template>
  <PrimeChip
    :image="images.get(who)"
    :label="`Vismo ${names.get(who) || '?'}`"
    :pt="{
      image: { alt: `Vismo ${names.get(who) || '?'}`, width: 32, height: 32 },
    }"
  />
</template>

<style scoped lang="scss"></style>
